import { LinkProps } from "@tanstack/react-router";
import { OrganizationStatus } from "../service/organization";

export const COLORS = {
  light: {
    LIVE: "#86EFAC", // pastel green
    NEW: "#93C5FD", // pastel blue
    ONBOARDING: "#FCD34D", // pastel yellow
    GESTATING: "#DDD6FE", // pastel purple
    DEAD: "#E5E7EB", // pastel gray
    TEST: "#FCA5A5", // pastel red
  },
  dark: {
    LIVE: "#10B981", // darker green
    NEW: "#3B82F6", // darker blue
    ONBOARDING: "#F59E0B", // darker yellow
    GESTATING: "#8B5CF6", // darker purple
    DEAD: "#4B5563", // darker gray
    TEST: "#EF4444", // darker red
  },
};

export const STATUS_COLORS: Record<OrganizationStatus, string> = {
  LIVE: COLORS.light.LIVE,
  NEW: COLORS.light.NEW,
  ONBOARDING: COLORS.light.ONBOARDING,
  GESTATING: COLORS.light.GESTATING,
  DEAD: COLORS.light.DEAD,
  TEST: COLORS.light.TEST,
};

export const STATUS_COLORS_DARK: Record<OrganizationStatus, string> = {
  LIVE: COLORS.dark.LIVE,
  NEW: COLORS.dark.NEW,
  ONBOARDING: COLORS.dark.ONBOARDING,
  GESTATING: COLORS.dark.GESTATING,
  DEAD: COLORS.dark.DEAD,
  TEST: COLORS.dark.TEST,
};

export const CHART_STYLES = {
  fontSize: "12px",
  fontFamily: "Inter, sans-serif",
  legend: {
    fontSize: "11px",
    iconSize: 8,
  },
};

export type TopNavItem = {
  title: string;
  href: LinkProps["to"];
  isActive: boolean;
  disabled: boolean;
};

export const TOP_NAV: TopNavItem[] = [
  {
    title: "Overview",
    href: "/root-user/dashboard",
    isActive: true,
    disabled: false,
  },
  {
    title: "Analytics",
    href: "/root-user/dashboard/analytics",
    isActive: false,
    disabled: false,
  },
  {
    title: "Leads Analytics",
    href: "/root-user/dashboard/lead-analytics",
    isActive: false,
    disabled: false,
  },
];
